import React from 'react';
import { Radio, DatePicker, Button } from 'antd';
import { Moment } from 'moment';
import { FlexBoxCenter } from 'styles';
import { FormWrapper } from './styles';

const { RangePicker } = DatePicker;

interface PeriodSearchFilterProps {
  searchOption: 'ALL' | 'DATE';
  onSearchOptionChange: (value: 'ALL' | 'DATE') => void;
  paymentDate: [Moment, Moment] | null;
  onPaymentDateChange: (dates: [Moment, Moment] | null) => void;
  onSearch: () => void;
  isSearching?: boolean; // 조회 중 버튼 비활성화 (비동기 조회 시)
}

// 거래 내역 탭 / 기간 검색 조건 필터 (거래 건 별 · 회사 별 공용)
const PeriodSearchFilter = ({
  searchOption,
  onSearchOptionChange,
  paymentDate,
  onPaymentDateChange,
  onSearch,
  isSearching = false
}: PeriodSearchFilterProps) => {
  return (
    <FormWrapper>
      <div className="fieldName">기간 검색 조건</div>
      <FlexBoxCenter style={{ width: '100%', padding: '0px 16px', border: '1px solid #f0f0f0' }}>
        <Radio.Group value={searchOption} onChange={({ target }) => onSearchOptionChange(target?.value)}>
          <Radio value="ALL">전체</Radio>
          <Radio value="DATE">
            <div style={{ display: 'flex', alignItems: 'center' }}>
              <span style={{ paddingRight: '16px' }}>기간 검색</span>
              <RangePicker
                size="middle"
                value={paymentDate}
                style={{ marginRight: '8px' }}
                disabled={searchOption === 'ALL'}
                onChange={(dates) => onPaymentDateChange(dates as [Moment, Moment] | null)}
              />
              <Button
                type="primary"
                style={{ height: '32px', padding: '1px 16px 0px', borderRadius: '4px', fontSize: '14px' }}
                disabled={searchOption === 'ALL' || isSearching}
                loading={isSearching}
                onClick={onSearch}
              >
                조회
              </Button>
            </div>
          </Radio>
        </Radio.Group>
      </FlexBoxCenter>
    </FormWrapper>
  );
};

export default PeriodSearchFilter;
